import React from 'react';

export default function InteractionClusterDivider({ label }) {
  return (
    <div className="messenger-cluster-divider" role="separator">
      <span>{label}</span>
    </div>
  );
}
